import type {
  CircleElement,
  RectangleElement,
  TextStyleOverride,
  TriangleElement,
  VectorElement,
} from '@/components/canvas/document/publicTypes';
import {
  SHAPE_DEFAULT_FONT_SIZE,
  SHAPE_DEFAULT_FONT_WEIGHT,
  SHAPE_DEFAULT_TEXT_ALIGN,
  SHAPE_DEFAULT_TEXT_COLOR,
  SHAPE_DEFAULT_VERTICAL_ALIGN,
} from '@/components/canvas/shared/constants/legacyConfig';

export type ResolvedShapeTextStyle = {
  fontFamily: string;
  fontSize: number;
  fontWeight: number | string;
  fontStyle: 'normal' | 'italic';
  color: string;
  textAlign: 'left' | 'center' | 'right';
  verticalAlign: 'top' | 'middle' | 'bottom';
  writingMode?: 'horizontal-tb' | 'vertical-rl';
};

type ShapeTextElement = RectangleElement | CircleElement | TriangleElement | VectorElement;

/** 将元素根文字样式与 data.textStyle 局部覆盖合并，返回完整样式对象 */
export function resolveShapeTextStyle(
  element: ShapeTextElement,
  overrides: Partial<TextStyleOverride> | undefined = element.data.textStyle,
): ResolvedShapeTextStyle {
  const typography = overrides?.typography ?? {};
  const paragraph = overrides?.paragraph ?? {};
  return {
    fontFamily: typography.fontFamily ?? element.typography.fontFamily,
    fontSize: typography.fontSize ?? element.typography.fontSize ?? SHAPE_DEFAULT_FONT_SIZE,
    fontWeight: typography.fontWeight ?? element.typography.fontWeight ?? SHAPE_DEFAULT_FONT_WEIGHT,
    fontStyle: typography.fontStyle ?? element.typography.fontStyle ?? 'normal',
    color: typography.color ?? element.typography.color ?? SHAPE_DEFAULT_TEXT_COLOR,
    textAlign: paragraph.textAlign === 'justify'
      ? 'left'
      : paragraph.textAlign ?? (element.paragraph.textAlign === 'justify' ? 'left' : element.paragraph.textAlign) ?? SHAPE_DEFAULT_TEXT_ALIGN,
    verticalAlign: paragraph.verticalAlign ?? SHAPE_DEFAULT_VERTICAL_ALIGN,
    writingMode: paragraph.writingMode,
  };
}
